import ExternalLinkAlt from 'assets/icons/fa/external-link-alt.svg'

ExternalLinkAlt.displayName = 'ExternalLinkAlt'
export default ExternalLinkAlt
